import { HttpParams } from '@angular/common/http';

/**
 * Merges two HttpParams objects into a single HttpParams object.
 * Parameters from the second object will override those from the first if they have the same key.
 *
 * @param firstHttpParams - The first HttpParams object
 * @param secondHttpParams - The second HttpParams object
 * @returns A new HttpParams object containing merged parameters
 */
export function mergeQueryParams(firstHttpParams: HttpParams, secondHttpParams: HttpParams): HttpParams {
    let mergedParams = new HttpParams();

    // Add all parameters from the first HttpParams
    firstHttpParams.keys().forEach(key => {
        const values = firstHttpParams.getAll(key);
        if (values) {
            values.forEach(value => {
                mergedParams = mergedParams.append(key, value);
            });
        }
    });

    // Add all parameters from the second HttpParams (will override if same key exists)
    secondHttpParams.keys().forEach(key => {
        // Remove existing key from merged params if it exists
        if (mergedParams.has(key)) {
            mergedParams = mergedParams.delete(key);
        }

        const values = secondHttpParams.getAll(key);
        if (values) {
            values.forEach(value => {
                mergedParams = mergedParams.append(key, value);
            });
        }
    });

    return mergedParams;
}
